module.exports = __webpack_public_path__ + "img/S_299.6d06d548.png";